export const phone_code = [
  { name: "An Giang", code: "296" },
  { name: "Bà Rịa - Vũng Tàu", code: "254" },
  { name: "Bắc Cạn", code: "209" },
  { name: "Bắc Giang", code: "204" },
  { name: "Bạc Liêu", code: "291" },
  { name: "Bắc Ninh", code: "222" },
  { name: "Bến Tre", code: "275" },
  { name: "Bình Định", code: "256" },
  { name: "Bình Dương", code: "274" },
  { name: "Bình Phước", code: "271" },
  { name: "Bình Thuận", code: "252" },
  { name: "Cà Mau", code: "290" },
  { name: "Cần Thơ", code: "292" },
  { name: "Cao Bằng", code: "206" },
  { name: "Đà Nẵng", code: "236" },
  { name: "Đắk Lắk", code: "262" },
  { name: "Đắk Nông", code: "261" },
  { name: "Điện Biên", code: "215" },
  { name: "Đồng Nai", code: "251" },
  { name: "Đồng Tháp", code: "277" },
  { name: "Gia Lai", code: "269" },
  { name: "Hà Giang", code: "219" },
  { name: "Hà Nam", code: "226" },
  { name: "Hà Nội", code: "24" },
  { name: "Hà Tĩnh", code: "239" },
  { name: "Hải Dương", code: "220" },
  { name: "Hải Phòng", code: "225" },
  { name: "Hậu Giang", code: "293" },
  { name: "Hồ Chí Minh", code: "28" },
  { name: "Hòa Bình", code: "218" },
  { name: "Hưng Yên", code: "221" },
  { name: "Khánh Hoà", code: "258" },
  { name: "Kiên Giang", code: "297" },
  { name: "Kon Tum", code: "260" },
  { name: "Lai Châu", code: "213" },
  { name: "Lâm Đồng", code: "263" },
  { name: "Lạng Sơn", code: "205" },
  { name: "Lào Cai", code: "214" },
  { name: "Long An", code: "272" },
  { name: "Nam Định", code: "228" },
  { name: "Nghệ An", code: "238" },
  { name: "Ninh Bình", code: "229" },
  { name: "Ninh Thuận", code: "259" },
  { name: "Phú Thọ", code: "210" },
  { name: "Phú Yên", code: "257" },
  { name: "Quảng Bình", code: "232" },
  { name: "Quảng Nam", code: "235" },
  { name: "Quảng Ngãi", code: "255" },
  { name: "Quảng Ninh", code: "203" },
  { name: "Quảng Trị", code: "233" },
  { name: "Sóc Trăng", code: "299" },
  { name: "Sơn La", code: "212" },
  { name: "Tây Ninh", code: "276" },
  { name: "Thái Bình", code: "227" },
  { name: "Thái Nguyên", code: "208" },
  { name: "Thanh Hóa", code: "237" },
  { name: "Thừa Thiên - Huế", code: "234" },
  { name: "Tiền Giang", code: "273" },
  { name: "Trà Vinh", code: "294" },
  { name: "Tuyên Quang", code: "207" },
  { name: "Vĩnh Long", code: "270" },
  { name: "Vĩnh Phúc", code: "211" },
  { name: "Yên Bái", code: "216" },
  { name: "Việt Nam", code: "84" }
];
let list = phone_code.map(a => a.code);
export const phone_code_list = list.join("|");
